export function getTimeText({
  startTime,
  endTime,
}: {
  startTime: string;
  endTime?: string;
}) {
  let btnText = '';
  if (startTime && startTime !== '00:00') {
    btnText = startTime;
  }
  if (endTime && endTime !== '00:00') {
    btnText += `-${endTime}`;
  }

  return btnText;
}
